import React from 'react';
import { CardSectionHeader } from '..';
import { GLOBAL_THEME_COLOR } from '@constants/theme';

type Props = {
  title: string;
};

const ReservationListColumnHeader = ({ title }: Props) => {
  return (
    <CardSectionHeader
      style={{
        color: GLOBAL_THEME_COLOR.$dark_text_color,
        fontSize: 10,
      }}
      title={title}
    />
  );
};

export default ReservationListColumnHeader;
